module.exports = __webpack_public_path__ + "media/lacto-medium.4797df6e.mp4";